"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.APIClient = exports.EParameterEncoding = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fetchApi = require("./fetchApi");

var _fetchApi2 = _interopRequireDefault(_fetchApi);

var _reactRefetch = require("react-refetch");

var _reduxActions = require("redux-actions");

var _joi = require("joi");

var Joi = _interopRequireWildcard(_joi);

var _lodash = require("lodash");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments)).next());
    });
};
var EParameterEncoding = exports.EParameterEncoding = undefined;
(function (EParameterEncoding) {
    EParameterEncoding[EParameterEncoding["URL"] = 0] = "URL";
    EParameterEncoding[EParameterEncoding["JSON"] = 1] = "JSON";
})(EParameterEncoding || (exports.EParameterEncoding = EParameterEncoding = {}));

var APIClient = exports.APIClient = function () {
    function APIClient(accessToken, refreshToken, isAuthorized, forceLogout) {
        _classCallCheck(this, APIClient);

        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
        this.isAuthorized = isAuthorized;
        this.forceLogout = forceLogout;
    }

    _createClass(APIClient, [{
        key: "buildOptions",
        value: function buildOptions(target) {
            var _arguments2 = arguments,
                _this = this;

            var includeAPIBaseUrl = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

            var headers = null;
            if (target.headers && target.headers.Accept) {
                headers = target.headers;
            } else {
                headers = Object.assign({
                    "Accept": "application/json"
                }, target.headers);
            }
            if (target.parameters instanceof FormData === false) {
                headers = Object.assign({
                    "Content-Type": "application/json"
                }, headers);
            }
            // default auth
            var auth = target.authorization;
            if ((0, _lodash.isUndefined)(auth) === true) {
                auth = "auth";
            }
            switch (auth) {
                case "auth":
                    if (this.isAuthorized() && this.accessToken()) {
                        headers = Object.assign({
                            "Authorization": "Bearer " + this.accessToken()
                        }, headers);
                    } else if (this.refreshToken()) {} else {
                        throw new Error("Not authorized" + target);
                    }
                    break;
                case "optionalAuth":
                    headers = Object.assign({
                        "Authorization": "Bearer " + this.accessToken()
                    }, headers);
                    break;
                case "noAuth":
                    break;
            }
            // refetch options
            var options = {};
            // https://github.com/heroku/react-refetch/blob/master/docs/api.md#connectmappropstorequeststoprops-options
            if (includeAPIBaseUrl) {
                options = {
                    url: __API_BASE_URL__ + "/" + target.url
                };
            }
            // react-refetch only options
            // if this is an authorized call target, automatically catch unauthenticated 401 and 403 forbidden errors and log the user out
            if (auth === "auth") {
                // chainable requests: https://github.com/heroku/react-refetch/pull/6
                options.catch = function (reason, meta) {
                    console.warn("core/APIClient.buildOptions: error reponse was received", reason, meta);
                    console.log(reason, meta, _arguments2);
                    if (reason.cause && reason.cause.statusCode) {
                        _this.forceLogout(reason.cause.statusCode);
                    }
                    return undefined; // Return undefined in catch to do side-effects after a rejected request, leaving the request as is.
                };
            }
            return Object.assign({
                method: target.method,
                body: target.parameters instanceof FormData ? target.parameters : JSON.stringify(target.parameters),
                queryMap: target.queryMap,
                headers: headers
            }, options);
        }
    }, {
        key: "buildRefetchOptions",
        value: function buildRefetchOptions(target) {
            var customRefetchOptions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

            var defaultOptions = {};
            var builtOptions = this.buildOptions(target);
            if ((0, _lodash.isUndefined)(builtOptions.method) || builtOptions.method === "GET") {
                defaultOptions.refreshing = true; // GET requests must always be refreshing.
            } else {
                defaultOptions.force = true; // non GET requests are forced by default!
            }
            return Object.assign({}, defaultOptions, builtOptions, customRefetchOptions);
        }
    }, {
        key: "forceRefetchOption",
        value: function forceRefetchOption(refetchOption) {
            return Object.assign({}, refetchOption, { force: true });
        }
    }, {
        key: "forcedRefetch",
        value: function forcedRefetch(wrappedRefetchOption) {
            var _this2 = this;

            return (0, _lodash.mapValues)(wrappedRefetchOption, function (refetchOption) {
                return _this2.forceRefetchOption(refetchOption);
            });
        }
    }, {
        key: "request",
        value: function request(target) {
            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee() {
                var options, result;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                options = this.buildOptions(target);
                                _context.prev = 1;
                                _context.next = 4;
                                return (0, _fetchApi2.default)(__API_BASE_URL__ + "/" + target.url, options, {});

                            case 4:
                                result = _context.sent;
                                return _context.abrupt("return", result);

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](1);

                                // attention, this is dependend on the error response decoration inside the fetchApi
                                if (_context.t0.response && _context.t0.response.status) {
                                    // sideeffect, if this was an authenticated call, auto-logout the user.
                                    console.warn("core/APIClient.request: error reponse was received", _context.t0.response, target);
                                    if (target.authorization === "auth" || (0, _lodash.isUndefined)(target.authorization)) {
                                        // undefined auth = authenticated request by default!
                                        // console.log("Force logout!");
                                        this.forceLogout(_context.t0.response.status);
                                    }
                                } else {
                                    console.error("core/APIClient.request: error reponse without reponse decoration was received", _context.t0);
                                }
                                // rethrow the original error
                                throw _context.t0;

                            case 12:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1, 8]]);
            }));
        }
    }, {
        key: "requestJSON",
        value: function requestJSON(target) {
            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee2() {
                var requestResult;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.request(target);

                            case 2:
                                requestResult = _context2.sent;
                                return _context2.abrupt("return", requestResult.json());

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));
        }
    }, {
        key: "requestType",
        value: function requestType(target) {
            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee3() {
                var jsonResult;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.requestJSON(target);

                            case 2:
                                jsonResult = _context3.sent;

                                if (!target.schema) {
                                    _context3.next = 5;
                                    break;
                                }

                                return _context3.abrupt("return", this.validate(jsonResult, target));

                            case 5:
                                return _context3.abrupt("return", jsonResult);

                            case 6:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));
        }
    }, {
        key: "requestReduxType",
        value: function requestReduxType(target, _ref, dispatch) {
            var _ref2 = _slicedToArray(_ref, 3);

            var pending = _ref2[0];
            var complete = _ref2[1];
            var error = _ref2[2];

            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee5() {
                var _this3 = this;

                var promiseState, _ret;

                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                promiseState = _reactRefetch.PromiseState.create(target);

                                dispatch((0, _reduxActions.createAction)(pending, function () {
                                    return promiseState;
                                })());
                                _context5.prev = 2;
                                return _context5.delegateYield(regeneratorRuntime.mark(function _callee4() {
                                    var requestTypeResult, successPromiseState;
                                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                                        while (1) {
                                            switch (_context4.prev = _context4.next) {
                                                case 0:
                                                    _context4.next = 2;
                                                    return _this3.requestType(target);

                                                case 2:
                                                    requestTypeResult = _context4.sent;
                                                    successPromiseState = _reactRefetch.PromiseState.resolve(requestTypeResult, target);

                                                    dispatch((0, _reduxActions.createAction)(complete, function () {
                                                        return successPromiseState;
                                                    })());
                                                    return _context4.abrupt("return", {
                                                        v: requestTypeResult
                                                    });

                                                case 6:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                        }
                                    }, _callee4, _this3);
                                })(), "t0", 4);

                            case 4:
                                _ret = _context5.t0;

                                if (!((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object")) {
                                    _context5.next = 7;
                                    break;
                                }

                                return _context5.abrupt("return", _ret.v);

                            case 7:
                                _context5.next = 12;
                                break;

                            case 9:
                                _context5.prev = 9;
                                _context5.t1 = _context5["catch"](2);

                                (function () {
                                    var rejectedPromiseState = _reactRefetch.PromiseState.reject(_context5.t1, target);
                                    dispatch((0, _reduxActions.createAction)(error, function () {
                                        return rejectedPromiseState;
                                    })());
                                    throw _context5.t1;
                                })();

                            case 12:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[2, 9]]);
            }));
        }
    }, {
        key: "requestReduxJSON",
        value: function requestReduxJSON(target, _ref3, dispatch) {
            var _ref4 = _slicedToArray(_ref3, 3);

            var pending = _ref4[0];
            var complete = _ref4[1];
            var error = _ref4[2];

            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee7() {
                var _this4 = this;

                var promiseState, _ret3;

                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                promiseState = _reactRefetch.PromiseState.create(target);

                                dispatch((0, _reduxActions.createAction)(pending, function () {
                                    return promiseState;
                                })());
                                _context7.prev = 2;
                                return _context7.delegateYield(regeneratorRuntime.mark(function _callee6() {
                                    var requestTypeResult, successPromiseState;
                                    return regeneratorRuntime.wrap(function _callee6$(_context6) {
                                        while (1) {
                                            switch (_context6.prev = _context6.next) {
                                                case 0:
                                                    _context6.next = 2;
                                                    return _this4.requestJSON(target);

                                                case 2:
                                                    requestTypeResult = _context6.sent;
                                                    successPromiseState = _reactRefetch.PromiseState.resolve(requestTypeResult, target);

                                                    dispatch((0, _reduxActions.createAction)(complete, function () {
                                                        return successPromiseState;
                                                    })());
                                                    return _context6.abrupt("return", {
                                                        v: requestTypeResult
                                                    });

                                                case 6:
                                                case "end":
                                                    return _context6.stop();
                                            }
                                        }
                                    }, _callee6, _this4);
                                })(), "t0", 4);

                            case 4:
                                _ret3 = _context7.t0;

                                if (!((typeof _ret3 === "undefined" ? "undefined" : _typeof(_ret3)) === "object")) {
                                    _context7.next = 7;
                                    break;
                                }

                                return _context7.abrupt("return", _ret3.v);

                            case 7:
                                _context7.next = 12;
                                break;

                            case 9:
                                _context7.prev = 9;
                                _context7.t1 = _context7["catch"](2);

                                (function () {
                                    var rejectedPromiseState = _reactRefetch.PromiseState.reject(_context7.t1, target);
                                    dispatch((0, _reduxActions.createAction)(error, function () {
                                        return rejectedPromiseState;
                                    })());
                                    throw _context7.t1;
                                })();

                            case 12:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, this, [[2, 9]]);
            }));
        }
    }, {
        key: "requestRedux",
        value: function requestRedux(target, _ref5, dispatch) {
            var _ref6 = _slicedToArray(_ref5, 3);

            var pending = _ref6[0];
            var complete = _ref6[1];
            var error = _ref6[2];

            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee9() {
                var _this5 = this;

                var promiseState, _ret5;

                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                promiseState = _reactRefetch.PromiseState.create(target);

                                dispatch((0, _reduxActions.createAction)(pending, function () {
                                    return promiseState;
                                })());
                                _context9.prev = 2;
                                return _context9.delegateYield(regeneratorRuntime.mark(function _callee8() {
                                    var requestTypeResult, successPromiseState;
                                    return regeneratorRuntime.wrap(function _callee8$(_context8) {
                                        while (1) {
                                            switch (_context8.prev = _context8.next) {
                                                case 0:
                                                    _context8.next = 2;
                                                    return _this5.request(target);

                                                case 2:
                                                    requestTypeResult = _context8.sent;
                                                    successPromiseState = _reactRefetch.PromiseState.resolve(requestTypeResult, target);

                                                    dispatch((0, _reduxActions.createAction)(complete, function () {
                                                        return successPromiseState;
                                                    })());
                                                    return _context8.abrupt("return", {
                                                        v: requestTypeResult
                                                    });

                                                case 6:
                                                case "end":
                                                    return _context8.stop();
                                            }
                                        }
                                    }, _callee8, _this5);
                                })(), "t0", 4);

                            case 4:
                                _ret5 = _context9.t0;

                                if (!((typeof _ret5 === "undefined" ? "undefined" : _typeof(_ret5)) === "object")) {
                                    _context9.next = 7;
                                    break;
                                }

                                return _context9.abrupt("return", _ret5.v);

                            case 7:
                                _context9.next = 12;
                                break;

                            case 9:
                                _context9.prev = 9;
                                _context9.t1 = _context9["catch"](2);

                                (function () {
                                    var rejectedPromiseState = _reactRefetch.PromiseState.reject(_context9.t1, target);
                                    dispatch((0, _reduxActions.createAction)(error, function () {
                                        return rejectedPromiseState;
                                    })());
                                    throw _context9.t1;
                                })();

                            case 12:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, this, [[2, 9]]);
            }));
        }
    }, {
        key: "validate",
        value: function validate(json, target) {
            // JOI definition from target will be used here to validate the json and finally map it to T
            var validationResult = Joi.validate(json, target.schema);
            if (validationResult.error) {
                console.error("core/APIClient.request.validate: Failed to validate json payload to schema", validationResult, target, json);
                throw new Error("Response validation of url " + target.url + " failed: " + validationResult.error.message);
            }
            return validationResult.value;
        }
    }]);

    return APIClient;
}();


/*****************
 ** WEBPACK FOOTER
 ** ./src/core/APIClient.ts
 ** module id = 1309
 ** module chunks = 0
 **/